<template>
    <span ref="input" class="ah-el-input-bank-acc">
        <el-input
            v-model.trim="inputVal"
            class="input"
            :disabled="disabled"
            :maxlength="maxlength || 20"
            show-word-limit
            :name="name"
            @paste.native.capture="onPaste"
            @blur="inputVal = $event.target.value"
        ></el-input>
    </span>
</template>

<script>
export default {
    name: 'ah-el-input-bank-acc',
    props: {
        value: {
            type: String,
            default: '',
        },
        disabled: Boolean,
        name: String,
        maxlength: {
            type: Number,
            default: 20,
        },
    },

    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.updateValue(val);
            },
        },
    },
    data() {
        return {
            isPaste: false,
        };
    },
    methods: {
        onPaste() {
            this.isPaste = true;
            setTimeout(() => {
                this.isPaste = false;
            }, 10);
        },
        updateValue(value) {
            this.$emit('input', this.getConverted(value));
        },
        getConverted(input) {
            let letterList = input.split('');
            if (this.isPaste) letterList = letterList.filter((o) => o !== '-');
            const newList = [];

            letterList.forEach((letter, index) => {
                if (!this.matchType(letter, index)) {
                    this.shake();
                    return;
                }
                newList.push(letter);
            });
            return newList.join('');
        },
        matchType(input) {
            if (!input) return false;

            const inputNumberFormat = Number(input);
            const ASCII = Number(input.codePointAt(0));
            const validCharList = [];

            const isNumber = !Number.isNaN(inputNumberFormat);

            if (isNumber || validCharList.includes(ASCII)) return true;
            return false;
        },
        shake() {
            if (this.isPaste) return;

            this.$refs.input.classList.add('shake');
            this.$refs.input.classList.add('shake-constant');
            setTimeout(() => {
                this.$refs.input.classList.remove('shake');
                this.$refs.input.classList.remove('shake-constant');
            }, 150);
        },
    },
};
</script>
<style lang="scss">
.ah-el-input-bank-acc {
    .el-input input {
        letter-spacing: 1px;
        font-weight: bold;
        font-size: 12pt;
    }
}
</style>
